import { render } from "./ButtonComponents.vue?vue&type=template&id=7ac6bb5b"
import script from "./ButtonComponents.vue?vue&type=script&lang=js"
export * from "./ButtonComponents.vue?vue&type=script&lang=js"

import "./ButtonComponents.vue?vue&type=style&index=0&id=7ac6bb5b&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__